<template>
    <div id="application-wrapper">
        <section class="onboarding">
            <div class="inner">
                <div class="section-header" >
                    <i :style="[step === 'locality' ? {'top': '30px'} : '']" class="back" @click="goStepBack"></i>

                  <span class="title" v-if="step !== 'locality' && step !== 'welcome'">{{ trans('home.create_account') }}</span>
                    <div class="navigation" v-if="step !== 'locality'">
                        <div class="dot" :class="{'active': step === 1}"></div>
                        <div class="dot" :class="{'active': step === 2}"></div>
                        <div class="dot" :class="{'active': step === 3}"></div>
                        <div class="dot" :class="{'active': step === 4}"></div>
                        <div class="dot" :class="{'active': step === 5}"></div>
                    </div>
                </div>
                <div dusk="registration-form" class="section-body" :style="[step === 'locality' ? {'padding-top': '20px'} : '']">
                    <Step1 v-if="step === 1" v-bind:vars="$data"></Step1>
                    <Step2 v-else-if="step === 2" v-bind:vars="$data"></Step2>
                    <Step3 v-else-if="step === 3" v-bind:vars="$data"></Step3>
                    <Step4 v-else-if="step === 4" v-bind:vars="$data"></Step4>
                    <Step5 v-else-if="step === 5" v-bind:vars="$data"></Step5>
                    <Location v-else-if="step === 'locality'" v-bind:vars="$data"></Location>
                </div>
            </div> 
        </section>
    </div>
</template>

<script>
    import Step1 from '@buddy/views/widgets/registration/Step1.vue';
    import Step2 from '@buddy/views/widgets/registration/Step2.vue';
    import Step3 from '@buddy/views/widgets/registration/Step3.vue';
    import Location from '@buddy/views/widgets/registration/Location.vue';
    import Step4 from '@buddy/views/widgets/registration/Step4.vue';
    import Step5 from "@buddy/views/widgets/registration/Step5.vue";

    export default {
        data() {
            return {
                step: 1,
                nickname: '',
                dob: this.registerDate(), //this needs moment globally for vee-validate to work
                email: '',
                password: '',
                link: '',
                showpassword: true,
                avatarPhoto: null,
                avatarPreview: null,
                avatarActions: {},
                acceptTerms: false,
                humanVerification: false,

                locationType: "",
                mapVisible: true,
                lat: 52.520389,
                lng: 13.40424,

                locality: 'Berlin',
                state: 'Berlin',
                country: 'Germany',
                country_code: 'DE',
                location: '',
                location_type: '',
                address_type: 'full_address',
                address: '',
                addressShow: this.trans('reg.location_defining'),
                addressError: null,
                skip_profile_picture: true,

                // Inner components variables
                honeypot: {
                    hide: false,
                    value: '',
                },
                handle_description: true,
                handle: '',
                nickNameStep : 1,
                firstopen : true,
                handle_suggestions : [],
                buttonToTop : false
            }
        },
        mixins: [require('@general/lib/mixin').default],
        components: {
            Step5,
            Step3,
            Step1,
            Step2,
            Location,
            Step4,
        },
        methods: {
            goStepBack(fallback) {
                if (this.step === 1) {
                    window.location.href = window.location.href.replace('register','')
                } else if(this.step === 'locality') {
                  this.step = 5;
                }else{
                  if(this.step === 3 && this.nickNameStep === 2){
                    this.nickNameStep = 1;
                  }else{
                    this.step--;
                  }
                }
            }
        },
        beforeMount() {
          if (app.isDesktop) {
              this.openRegisterModal();
              window.location.href = window.location.origin
          }
        }
    }
</script>
